module.exports = __webpack_public_path__ + "abedc577998825043439d472d0464bd4.svg";